import { action, computed, observable } from 'mobx'
import { KIND } from '../common/CaseDetail/constants'
import { formatCaseContent } from '../common/CaseDetail/utils'

class Store {
  @observable active // 显示被选中的面板
  @observable siteVisible = false // 现场图片上传弹窗
  @observable designVisible = false // 设计稿上传弹窗
  @observable list = []
  @observable showAreaRef // 展示区的ref节点，用于控制回到顶部

  @computed
  get getDesignImageLength() {
    const [designImageList] = this.list
    return designImageList?.imgs?.length ?? 0
  }

  @computed
  get getStageCeremonyImages() {
    return this.list.find(f => f?.kind === KIND['StageCeremony'])
  }

  @computed
  get getSignImages() {
    return this.list.find(f => f?.kind === KIND['WelcomeSign'])
  }

  @computed
  get getWeddingDetailImages() {
    return this.list.find(f => f?.kind === KIND['WeddingDetail'])
  }

  @computed
  get getNoSettingImages() {
    return this.list.find(f => f?.kind == KIND['NoSetting'])
  }

  // 获取舞台仪式区stage + 迎宾签到区sign + 婚礼详情wedding + 未分区noSet 全部图片总数
  @computed
  get getSiteImageLength() {
    // eslint-disable-next-line no-unused-vars
    const [_, __, stage, sign, wedding, noSet] = this.list
    return (
      (stage?.imgs?.length ?? 0) +
      (sign?.imgs?.length ?? 0) +
      (wedding?.imgs?.length ?? 0) +
      (noSet?.imgs?.length ?? 0)
    )
  }

  @action setActive = val => (this.active = val)

  @action
  setList = list => {
    this.list = formatCaseContent(list)
  }

  @action setSiteVisible = val => (this.siteVisible = val)

  @action setDesignVisible = val => (this.designVisible = val)

  @action initShowAreaRef = ref => (this.showAreaRef = ref)
}

export default Store
